module.exports = __webpack_public_path__ + "img/gu.fc80ca1.svg";